import styled from '@emotion/styled'
import { gsColors } from '../../../styles/Variables'
import { mq } from '../../../helpers'

export const PressWrapper = styled.div`
  width: 90vw;
  display: flex;
  flex-direction: column;
  align-items: center;

  .content {
    width: 70%;

    ${mq('max', '1110px')} {
      width: 80%;
    }

    ${mq('max', '730px')} {
      width: 90%;
    }

    .header {
      width: 100%;
      height: 267px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;

      &:focus {
        outline: none;
      }
    }

    .press-links {
      width: 100%;
      // display: flex;
      // flex-direction: row;
      // flex-wrap: wrap;
      justify-content: space-evenly;
      gap: 15px;
      justify-items: center;

      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(150px, 150px));

      a {
        width: 164px;
        aspect-ratio: 1 / 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: transparent;
        font-family: Brown;
        font-size: 16px;
        text-decoration: none;
        color: black;
        transition: color 0.5s ease;

        ${mq('max', '450px')} {
          margin: 10px 10px 50px;
        }

        .press-image {
          border: 0.5px solid ${gsColors.paleSlate};
          margin-bottom: 1rem;
          width: 100%;
          height: 100%;
          aspect-ratio: 1 / 1;
          overflow: hidden;

          img {
            max-width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        &:hover {
          cursor: pointer;
          color: ${gsColors.sunsetOrange};
        }

        &:hover .press-image {
          border: 0.5px solid ${gsColors.sunsetOrange};
        }
      }
    }

    .article {
      display: flex;
      gap: 20px;

      ${mq('max', '768px')} {
        flex-direction: column;
      }

      .preview {
        width: 70%;
        display: flex;
        justify-content: center;

        ${mq('max', '768px')} {
          width: 100%;
        }

        .swiper-container {
          width: 100%;
          .swiper-wrapper {
            width: 100%;
          }
        }

        .swiper-button-prev,
        .swiper-button-next {
          color: ${gsColors.grape};
        }

        .swiper-pagination-bullet {
          background-color: ${gsColors.grape};
        }

        .single-article {
          min-width: 80%;
          // width: 80%;
          height: auto;
          border: 0.5px solid ${gsColors.paleSlate};

          ${mq('max', '768px')} {
            min-width: 100%;
            max-width: 100%;
          }
        }

        .image-slide-container {
          min-width: 100%;
          display: flex;
          justify-content: center;

          .slide-image {
            min-width: 80%;
            max-width: 80%;
            border: 0.5px solid ${gsColors.paleSlate};
            height: auto;
          }
        }
      }

      .info {
        width: 30%;

        ${mq('max', '768px')} {
          width: 100%;
        }

        .container {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;

          ${mq('max', '768px')} {
            width: 100%;
          }

          .section {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: flex-start;

            a {
              // padding-left: 0;
              text-align: left;
              color: ${gsColors.sunsetOrange};
              text-decoration: none;
            }

            button {
              margin-top: 1rem;
            }
          }
        }
      }
    }
  }
`

export const Divider = styled.div`
  width: 100%;
  border-top: 0.5px solid ${gsColors.paleSlate};
`
